import React, {Component, ReactElement} from "react";
import {DurableFunctionInstance, DurableFunctionInstanceHelpers, GroundFloorDurableFunctionInstance} from "../models/DurableFunctionInstance";
import TableCell from "./TableCell";
import SchoolCell from "./SchoolCell";
import DurableFunctionInstanceDuration from "./DurableFunctionInstanceDuration";
import Table, {TableColumn} from "./Table";
import {TableRowProps} from "./TableRow";
import GroundFloorDurableFunctionInstanceStatus from "./GroundFloorDurableFunctionInstanceStatus";
import {IndexedSchools} from "../utils/IndexedSchools";
import {friendlySchoolName} from "../utils/Utils";

interface GroundFloorDurableFunctionInstanceListProps
{
    title: string;
    enableRowLinks: boolean;
    instances: GroundFloorDurableFunctionInstance[];
    indexedSchools: IndexedSchools;
    headerExtra?: JSX.Element;
    openRowLinksInNewTab?: boolean;
    isLoading?: boolean;
    virtualize?: boolean;
}

interface GroundFloorDurableFunctionInstanceListState
{

}

export default class GroundFloorDurableFunctionInstanceList extends Component<GroundFloorDurableFunctionInstanceListProps, GroundFloorDurableFunctionInstanceListState>
{
    static columns: TableColumn[] = [
        {title: "Workload", propertyPath: "mobileWorkload",flex:3, showSmallScreen: true,showLargeScreen: false},
        { title: "Name", propertyPath: "name", flex: 2, showSmallScreen: false},
        { title: "School", propertyPath: "school", flex: 2,showSmallScreen: false},
        { title: "Created By", propertyPath: "createdBy", enableSort: false, flex: 2 ,showSmallScreen: false},
        { title: "Created", propertyPath: "createdAt", enableSort: true, type: "date", flex: 1 ,showSmallScreen: false},
        { title: "Duration", propertyPath: "duration", flex: 1 ,showSmallScreen: false},
        { title: "Status", propertyPath: "status", flex: 1, showSmallScreen: true},
    ];

    public componentDidMount() {
    }

    private buildWorkloadCell(instance: GroundFloorDurableFunctionInstance,extraDetail: string,flex: number) {
        let name = DurableFunctionInstanceHelpers.GetDurableFunctionInstanceName(instance)

        return (
            <TableCell key={instance.durableFunctionInstanceId} to={`/cdb-admin/workloads/${instance.durableFunctionInstanceId}`} enableLink={!this.props.enableRowLinks} flex={flex}>
                <span>{name}</span>
                <span className={"cdb-table__extra-detail"}>{extraDetail}</span>
            </TableCell>
        );
    }

    private rowPropsForInstance = (instance: DurableFunctionInstance): TableRowProps => {
        
        if (this.props.enableRowLinks)
        {
            return {
                to: this.props.enableRowLinks ? `/cdb-admin/workloads/${instance.durableFunctionInstanceId}` : undefined,
                enableRowLink: this.props.enableRowLinks,
                openInNewTab: this.props.openRowLinksInNewTab
            };
        }
        else
        {
            return {
                enableRowLink: false
            }
        }
    }
    

    private cellForColumn = (instance: GroundFloorDurableFunctionInstance, column: TableColumn, columnIndex: number): ReactElement<TableCell> | undefined => {

        switch (column.propertyPath) {
            case "name":
                return this.buildWorkloadCell(instance,instance.durableFunctionInstanceId,2);

            case "school":
                if (instance.bulkWorkloadName)
                {
                    return undefined;
                }
                else
                {
                    const schoolForInstance = this.props.indexedSchools.tenantNameSchoolCode[`${instance.tenantName}-${instance.schoolCode}`];
                    return (
                        <SchoolCell key={columnIndex} school={schoolForInstance} schoolKey={instance} enableLink={!this.props.enableRowLinks} flex={column.flex} />
                        );
                }
            case "status":
                return (
                    <GroundFloorDurableFunctionInstanceStatus key={columnIndex} durableFunctionInstance={instance} flex={column.flex}>
                    </GroundFloorDurableFunctionInstanceStatus>
                );

            case "duration":
                return (
                    <DurableFunctionInstanceDuration key={columnIndex} durableFunctionInstance={instance} flex={column.flex}>
                    </DurableFunctionInstanceDuration>
                );

            case "mobileWorkload":
                if(instance.bulkWorkloadName)
                {
                    return this.buildWorkloadCell(instance,instance.durableFunctionInstanceId,column.flex);
                }
                else
                {
                    const schoolForInstance = this.props.indexedSchools.tenantNameSchoolCode[`${instance.tenantName}-${instance.schoolCode}`];
                    return this.buildWorkloadCell(instance,friendlySchoolName(schoolForInstance),column.flex);
                }
            case "createdBy":
                return (
                    <TableCell key={columnIndex} flex={column.flex}>
                        <span>{instance.createdByUserPrincipalName}</span>
                    </TableCell>
                );

            default:
                return undefined;
        }
    };
    
    public render() {

        return (
            <Table
                className={this.props.virtualize ? "flex-item--flex-1" : ""}
                title={this.props.title}
                items={this.props.instances}
                columns={GroundFloorDurableFunctionInstanceList.columns}
                rowPropsForItem={this.rowPropsForInstance}
                cellForColumn={this.cellForColumn}
                enableSort={true}
                emptyMessage={"No workloads found"}
                virtualize={!!this.props.virtualize}
                loading={this.props.isLoading}>
                {this.props.headerExtra}
            </Table>

        );
    }
}